import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_BUeOruAJb99s: {
	id: 'prd_BUeOr2DEV2uAJb99s'
	ident: 'prd_BUeOruAJb99s'
	sku: 'simple_premium_4w_15_19_4w_38_95_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: 1
			price_id: 'prc_qhsIn2DEV2PeFCl8p'
			amount: 38.95
			amount_usd: 15.19
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 15.19
			discount: 23.76
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: null
			price_id: 'prc_bEVdP2DEV2lJIAgK9'
			amount: 38.95
			amount_usd: 38.95
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_BUeOruAJb99s, SubscriptionProduct>
const prd_BUeOruAJb99s = { ident: 'prd_BUeOruAJb99s' } as typeof _prd_BUeOruAJb99s

export default prd_BUeOruAJb99s
